export interface IDateCalculateBehavior {
  items: IDateCalculateItem[];
}

export interface IDateCalculateItem {
  isObject: boolean;
  reference: IDateCalculateObject | IDateCalculateNumber;
}

export interface IDateCalculateObject extends IDateCalculateBase {
  type: string;
  key: string;
  name?: string; // 設定UIで表示する名称（UIクラス内でセットする）
}

export interface IDateCalculateNumber extends IDateCalculateBase {
  value: number;
}

export interface IDateCalculateBase {
  itemType: string;
  option: string;
  operator?: string;
  id?: number; // 設定UIで表示するオブジェクトID（UIクラス内でセットする）
}

export function instanceOfIDateCalculateObject(instance: any): instance is IDateCalculateObject {
  return instance
    && instance.type
    && instance.key
    && instance.itemType
    && instance.option;
}

export function instanceOfIDateCalculateNumber(instance: any): instance is IDateCalculateNumber {
  return instance
    && instance.value
    && instance.itemType
    && instance.option;
}
